import { useFormContext } from "react-hook-form";
import { Input, Textarea } from "rizzui";
import cn from "@/utils/class-names";
import FormGroup from "@/app/shared/form-group";
import FileInput from "./file-input";
import { HOST_API_URL } from "config";

interface FormSystemSettingProps {
    className?: string;
}

export default function FormSystemSetting({
    className,
}: FormSystemSettingProps) {
    const {
        register,
        formState: { errors },
        setValue,
        watch, // Add this to watch form values
    } = useFormContext();

    const formData = watch(); // Add this to get form data

    return (
        <FormGroup
            title="System Settings"
            description="Enter the system settings information"
            className={cn(className)}
        >
            <Input
                label="Title"
                labelClassName="font-medium text-gray-900"
                placeholder="Name"
                {...register("name")}
                error={errors.name?.message as string}
            />

            <Input
                label="Sub Title"
                labelClassName="font-medium text-gray-900"
                placeholder="Sub Title"
                {...register("subTitle")}
                error={errors.subTitle?.message as string}
            />

            <Input
                label="Services Title"
                labelClassName="font-medium text-gray-900"
                placeholder="Services Title"
                {...register("servicesTitle")}
                error={errors.servicesTitle?.message as string}
            />

            <Input
                label="About Title"
                labelClassName="font-medium text-gray-900"
                placeholder="About Title"
                {...register("aboutTitle")}
                error={errors.aboutTitle?.message as string}
            />

            <Input
                label="Contact One"
                labelClassName="font-medium text-gray-900"
                placeholder="Contact One"
                {...register("contactOne")}
                error={errors.contactOne?.message as string}
            />

            <Input
                label="WhatsApp"
                labelClassName="font-medium text-gray-900"
                placeholder="WhatsApp"
                {...register("whatsApp")}
                error={errors.whatsApp?.message as string}
            />

            <Input
                label="Address"
                labelClassName="font-medium text-gray-900"
                placeholder="Address"
                {...register("address")}
                error={errors.address?.message as string}
            />

            <Input
                label="Email"
                labelClassName="font-medium text-gray-900"
                placeholder="Email"
                {...register("email")}
                error={errors.email?.message as string}
            />

            <Input
                label="Contact Two"
                labelClassName="font-medium text-gray-900"
                placeholder="Contact Two"
                {...register("contactTwo")}
                error={errors.contactTwo?.message as string}
            />

            <Input
                label="Contact Three"
                labelClassName="font-medium text-gray-900"
                placeholder="Contact Three"
                {...register("contactThree")}
                error={errors.contactThree?.message as string}
            />

            <Input
                label="Facebook"
                labelClassName="font-medium text-gray-900"
                placeholder="Facebook"
                {...register("facebook")}
                error={errors.facebook?.message as string}
            />

            <Input
                label="Twitter"
                labelClassName="font-medium text-gray-900"
                placeholder="Twitter"
                {...register("twitter")}
                error={errors.twitter?.message as string}
            />

            <Input
                label="Instagram"
                labelClassName="font-medium text-gray-900"
                placeholder="Instagram"
                {...register("instagram")}
                error={errors.instagram?.message as string}
            />

            <Input
                label="LinkedIn"
                labelClassName="font-medium text-gray-900"
                placeholder="LinkedIn"
                {...register("linkedIn")}
                error={errors.linkedIn?.message as string}
            />

            <Input
                label="YouTube"
                labelClassName="font-medium text-gray-900"
                placeholder="YouTube"
                {...register("youTube")}
                error={errors.youTube?.message as string}
            />

            <Textarea
                label="Hero Description"
                labelClassName="font-medium text-gray-900"
                rows={5}
                placeholder="Description"
                {...register("heroDescription")}
                error={errors.heroDescription?.message as string}
            />

            <Textarea
                label="Services Description"
                labelClassName="font-medium text-gray-900"
                rows={5}
                placeholder="Services Description"
                {...register("servicesDescription")}
                error={errors.servicesDescription?.message as string}
            />

            <Textarea
                label="About Description"
                labelClassName="font-medium text-gray-900"
                rows={5}
                placeholder="About Description"
                {...register("aboutDescription")}
                error={errors.aboutDescription?.message as string}
            />

            <Textarea
                label="Description"
                labelClassName="font-medium text-gray-900"
                rows={5}
                placeholder="Description"
                {...register("description")}
                error={errors.description?.message as string}
            />

            <FileInput
                label="Image"
                onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            // @ts-ignore
                            setValue("image", e.target.result);
                        };
                        reader.readAsDataURL(file);
                    }
                }}
            />

            <FileInput
                label="Icon"
                onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            // @ts-ignore
                            setValue("system.icon", e.target.result);
                        };
                        reader.readAsDataURL(file);
                    }
                }}
            />
            <div
                className={cn(
                    "grid gap-6 @2xl:grid-cols-2 @3xl:gap-10 border border-muted rounded px-3 py-5",
                )}
            >
                <img
                    src={
                        HOST_API_URL.replace("api", "") +
                            "/" +
                            formData?.image
                                ?.replace("wwwroot\\", "")
                                .replace(/\\/g, "/") || "image"
                    }
                    alt={
                        formData?.image
                            ?.replace("wwwroot\\", "")
                            .replace(/\\/g, "/") || "image"
                    }
                    className="w-full h-auto"
                    width={200}
                    height={200}
                />
            </div>
            <div
                className={cn(
                    "grid gap-6 @2xl:grid-cols-2 @3xl:gap-10 border border-muted rounded px-3 py-5",
                )}
            >
                <img
                    src={
                        HOST_API_URL.replace("api", "") +
                            "/" +
                            formData?.icon
                                ?.replace("wwwroot\\", "")
                                .replace(/\\/g, "/") || "icon"
                    }
                    alt={
                        formData?.icon
                            ?.replace("wwwroot\\", "")
                            .replace(/\\/g, "/") || "icon"
                    }
                    className="w-full h-auto"
                    width={200}
                    height={200}
                />
            </div>
        </FormGroup>
    );
}
